function isDevOrSandboxHost() {
  if (typeof window === 'undefined') return false;

  let hostname = '';
  try {
    const auth = window.MillaAuth;
    const cfg = auth && typeof auth.getConfig === 'function' ? auth.getConfig() : {};
    const issuer = cfg && cfg.issuer;
    hostname = issuer ? new URL(issuer).hostname : '';
  } catch (_) {
    // Fall back to the page hostname below.
  }

  if (!hostname) {
    hostname = (window.location && window.location.hostname) || '';
  }

  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') return true;
  return /(?:^|[.-])(?:dev|sandbox|staging)(?:[.-]|$)/.test(hostname);
}

function buildCdmPageOptions(csaConfig) {
  const pageOptions = {
    pubId: csaConfig.pubId,
    pageType: csaConfig.pageType,
    resultsPageBaseUrl: csaConfig.resultsPageBaseUrl,
    resultsPageQueryParam: csaConfig.resultsPageQueryParam
  };

  if (isDevOrSandboxHost()) {
    pageOptions.adtest = 'on';
  }

  return pageOptions;
}

module.exports = {
  buildCdmPageOptions,
  isDevOrSandboxHost
};
